// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
// Message d'un refus de connexion au back-office.
//
// Seul le 401 est une erreur d'identifiants. Le verrou par compte (429) ne se
// lève pas avec le bon mot de passe et la saturation de bcrypt (503) n'est pas
// une faute de saisie : tout autre refus est dit avec son propre motif, sinon
// un repli par code. Sans réponse du tout, c'est le réseau.
//
// Sans dépendance (ni React, ni MUI) : un test du backend joue
// messageDeConnexion sous node.

const punctuate = (t) => (/[.!?…]$/.test(t) ? t : `${t}.`);

export function messageDeConnexion(error) {
  const response = error?.response;
  if (!response) return 'Serveur injoignable. Vérifiez votre connexion et réessayez.';
  if (response.status === 401) {
    return 'Connexion impossible. Vérifiez votre adresse et votre mot de passe.';
  }
  const detail = response.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return punctuate(detail.trim());
  if (response.status === 429) {
    return 'Trop de tentatives : connexion suspendue. Réessayez dans quelques minutes.';
  }
  if (response.status === 503) return 'Service momentanément saturé. Réessayez dans quelques secondes.';
  return `Connexion refusée par le serveur (code ${response.status}). Réessayez plus tard.`;
}
